
import React from 'react'

/** Represents a step in the login flow */
export default class Step extends React.Component {

    render() {

        // Display container div
        return <div 
        className={this.props.className}
        style={{
            position: 'absolute',
            top: 0,
            left: (this.props.current > this.props.number ? '-100%' : (this.props.current < this.props.number ? '100%' : '0%')),
            width: '100%',
            height: '100%',
            transition: 'left 0.25s, opacity 0.25s',
            opacity: this.props.current != this.props.number ? '0' : '1'
        }}>
            {this.props.children}
        </div>

    }

}
